import styled from 'styled-components';
import { space, PaddingProps } from 'styled-system';

const Padding = styled.div<PaddingProps>(space);

export default Padding;
